<template>
  <v-card
    outlined
    class="pa-0 ma-0"
    :class="small ? 'py-6' : 'py-8'"
    :height="small ? '170px' : '232px'"
    :width="small ? '136px' : '168px'"
  >
    <v-card-text class="pa-0 ma-0">
      <div class="d-flex justify-center pa-0 mb-3">
        <v-skeleton-loader
          class="skeleton-circle"
          type="image"
          :width="small ? '64px' : '108px'"
          :height="small ? '64px' : '108px'"
          :min-width="small ? '64px' : '108px'"
          :min-height="small ? '64px' : '108px'"
        />
      </div>

      <div class="mt-1 px-6">
        <v-skeleton-loader type="text@2"></v-skeleton-loader>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'UserCardSkeleton',

  props: {
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
